import React from 'react';

export function PrivacyPolicyPage() {
  return (
    <div style={{ maxWidth: '800px', margin: '40px auto', padding: '32px 24px', background: '#111827', color: '#f3f4f6', borderRadius: '12px', border: '1px solid #1f2937', fontFamily: 'system-ui, -apple-system, sans-serif', lineHeight: 1.6 }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '8px', color: '#fff' }}>Política de Privacidade</h1>
      <div style={{ fontSize: '0.875rem', color: '#9ca3af', marginBottom: '28px' }}>Última atualização: 02 de Outubro de 2026</div>

      <p style={{ color: '#d1d5db', marginBottom: '16px' }}>
        A <strong>Inteligência e Negócios</strong> ("nós", "nosso" ou "empresa"), operadora da plataforma <strong>CRM Platform Suite</strong>, valoriza a privacidade e a segurança dos dados de seus usuários e clientes. Esta Política de Privacidade descreve como tratamos e protegemos as informações coletadas através do sistema e das integrações autorizadas, incluindo a Google APIs.
      </p>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>1. Informações que Coletamos</h2>
      <p style={{ color: '#9ca3af', marginBottom: '12px' }}>Podemos coletar e processar:</p>
      <ul style={{ paddingLeft: '20px', color: '#9ca3af', marginBottom: '16px' }}>
        <li><strong>Dados de Identificação:</strong> Nome, e-mail corporativo, telefone e dados da organização.</li>
        <li><strong>Dados de Campanhas Publicitárias:</strong> Estatísticas de desempenho de anúncios (impressões, cliques, custos, conversões) e identificadores técnicos concedidos via OAuth.</li>
        <li><strong>Telemetria e Logs:</strong> Registros técnicos para auditoria, prevenção a fraudes e garantia de SLA.</li>
      </ul>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>2. Integração com a Google Ads API</h2>
      <p style={{ color: '#9ca3af', marginBottom: '12px' }}>
        O acesso concedido através da Google Ads API é utilizado exclusivamente para operacionalizar o gerenciamento de anúncios autorizado pelo usuário:
      </p>
      <ul style={{ paddingLeft: '20px', color: '#9ca3af', marginBottom: '16px' }}>
        <li>Sincronização, criação e monitoramento de campanhas e grupos de anúncios configurados no CRM.</li>
        <li>Atribuição de conversões e geração de relatórios consolidados de retorno de investimento.</li>
        <li><strong>Garantia de Não Compartilhamento:</strong> Seus dados de publicidade nunca são vendidos nem utilizados para treinamento de modelos públicos de inteligência artificial.</li>
      </ul>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>3. Retenção e Controle dos Dados</h2>
      <p style={{ color: '#9ca3af', marginBottom: '16px' }}>
        Os dados permanecem sob custódia enquanto o serviço estiver ativo. O usuário pode desconectar a integração a qualquer momento pelo painel do CRM ou revogando os acessos no painel de segurança da sua conta Google.
      </p>

      <div style={{ marginTop: '32px', padding: '20px', background: 'rgba(59, 130, 246, 0.08)', borderLeft: '4px solid #3b82f6', borderRadius: '4px' }}>
        <strong>Contato do Encarregado de Proteção de Dados (DPO):</strong><br />
        E-mail: <a href="mailto:contato@inteligenciaenegocios.com.br" style={{ color: '#60a5fa' }}>contato@inteligenciaenegocios.com.br</a><br />
        Website: <a href="https://crm.inteligenciaenegocios.com.br" style={{ color: '#60a5fa' }}>https://crm.inteligenciaenegocios.com.br</a>
      </div>
    </div>
  );
}

export function TermsOfServicePage() {
  return (
    <div style={{ maxWidth: '800px', margin: '40px auto', padding: '32px 24px', background: '#111827', color: '#f3f4f6', borderRadius: '12px', border: '1px solid #1f2937', fontFamily: 'system-ui, -apple-system, sans-serif', lineHeight: 1.6 }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '8px', color: '#fff' }}>Termos de Serviço</h1>
      <div style={{ fontSize: '0.875rem', color: '#9ca3af', marginBottom: '28px' }}>Última atualização: 02 de Outubro de 2026</div>

      <p style={{ color: '#d1d5db', marginBottom: '16px' }}>
        Bem-vindo ao <strong>CRM Platform Suite</strong>, operado pela <strong>Inteligência e Negócios</strong>. Ao utilizar nossa plataforma e recursos integrados, você concorda expressamente com os seguintes Termos de Serviço.
      </p>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>1. Objeto da Plataforma</h2>
      <p style={{ color: '#9ca3af', marginBottom: '16px' }}>
        O CRM Platform Suite provê ferramentas em nuvem para automação de relacionamento com clientes, telemetria analítica, gestão de conversões e conexões com APIs de terceiros, incluindo Google Ads e Meta Ads.
      </p>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>2. Responsabilidade sobre Contas e Anúncios</h2>
      <p style={{ color: '#9ca3af', marginBottom: '16px' }}>
        O usuário é o único responsável pelos orçamentos, investimentos financeiros, diretrizes e criativos publicados em suas contas de anúncios através do sistema, devendo obedecer integralmente às políticas de publicidade do Google.
      </p>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>3. Cancelamento e Encerramento</h2>
      <p style={{ color: '#9ca3af', marginBottom: '16px' }}>
        O usuário pode rescindir ou desativar integrações a qualquer momento, mantendo os registros de auditoria exigidos por regulamentação fiscal e legal.
      </p>

      <div style={{ marginTop: '32px', padding: '20px', background: 'rgba(59, 130, 246, 0.08)', borderLeft: '4px solid #3b82f6', borderRadius: '4px' }}>
        <strong>Dúvidas sobre os Termos?</strong><br />
        E-mail: <a href="mailto:contato@inteligenciaenegocios.com.br" style={{ color: '#60a5fa' }}>contato@inteligenciaenegocios.com.br</a><br />
        Website: <a href="https://crm.inteligenciaenegocios.com.br" style={{ color: '#60a5fa' }}>https://crm.inteligenciaenegocios.com.br</a>
      </div>
    </div>
  );
}
